import type { ReceiptInput } from '@chukua/common';
import { useState } from 'react';
import { useToast } from '../../../../../shared/hooks/use-toast';
import { apiErrorMessage } from '../../../../../shared/policies/api-error-message';
import { recordedMessage } from '../policies/receipt-form';
import { recordReceipt } from '../receipts.api';

/** Records a receipt. A refusal (bad reference, duplicate) stays inline in the drawer; success toasts. */
export function useRecordReceipt() {
  const [error, setError] = useState<string | null>(null);
  const [saving, setSaving] = useState(false);
  const toast = useToast();

  /** Returns whether it saved, so the drawer stays open with its error showing when it did not. */
  async function record(input: ReceiptInput): Promise<boolean> {
    setError(null);
    setSaving(true);
    try {
      const receipt = await recordReceipt(input);
      toast.success(recordedMessage(receipt.reference));
      return true;
    } catch (err) {
      setError(apiErrorMessage(err) ?? 'Could not record the receipt — check the fields and try again.');
      return false;
    } finally {
      setSaving(false);
    }
  }

  return { error, saving, record, resetError: () => setError(null) };
}
